import React, { useEffect } from 'react';
import MainHeader from './MainHeader';
import Beginnings from './Beginnings';
import PageFooter from './PageFooter';

function JulianPage() {
  useEffect(() => {
    // Scroll to top animation when component mounts
    window.scrollTo({ 
      top: 0, 
      behavior: 'smooth' 
    });
  }, []);

  return (
    <>
      <MainHeader />
      
      <main className="main-content">
        <Beginnings />
      </main>
      
      <PageFooter />
    </>
  );
}

export default JulianPage;

